import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { Lock, Send } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

let resolver = null;
let opener = null;
export function usePinPrompt() {
  return () => new Promise((res) => { resolver = res; if (opener) opener(); });
}

export default function PinPromptRoot() {
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState("");
  const [err, setErr] = useState("");
  const [mode, setMode] = useState({ require_otp: false, owner_phone: "", twilio_verify: false });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  const refreshMode = async () => {
    try { const { data } = await api.get("/otp/status"); setMode(data); } catch (e) {}
  };
  opener = async () => { setPin(""); setErr(""); setSent(false); await refreshMode(); setOpen(true); };

  const submit = () => {
    if (pin.length < 4) { setErr("Enter 4-6 digit code"); return; }
    localStorage.setItem("edit_pin", pin);
    setOpen(false);
    if (resolver) resolver(pin);
  };

  const sendOtp = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/otp/send", {});
      setSent(true);
      toast.success(data.channel === "twilio-verify" ? "OTP sent to owner phone" : "Reminder sent (fallback)");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to send OTP");
    } finally { setSending(false); }
  };

  const otpMode = mode.require_otp;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-sm" data-testid="pin-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-sans">
            <Lock size={16} /> Confirm with Edit PIN
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Every edit and new entry requires the firm edit PIN configured at signup.
        </p>
        <div className="flex justify-center py-2">
          <InputOTP maxLength={6} value={pin} onChange={setPin} data-testid="pin-input">
            <InputOTPGroup>
              <InputOTPSlot index={0} /><InputOTPSlot index={1} /><InputOTPSlot index={2} />
              <InputOTPSlot index={3} /><InputOTPSlot index={4} /><InputOTPSlot index={5} />
            </InputOTPGroup>
          </InputOTP>
        </div>
        {err && <div className="text-xs text-red-600">{err}</div>}
        <div className="flex justify-end gap-2 mt-2">
          <Button variant="outline" onClick={() => setOpen(false)} data-testid="pin-cancel">Cancel</Button>
          <Button onClick={submit} className="btn-primary" data-testid="pin-submit">Confirm</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
